
import Vue from 'vue';
import initializeSitchButtons from 'sitch-embed';
export default Vue.extend({
  mounted() {
    initializeSitchButtons();
  },
});
